import { useContext } from "react";
import { useMutation, useQueryClient } from "@tanstack/react-query";
import CheckUpContext from "../../context/check-up";
import UserContext from "../../context/user";

const useCheckUpCompleteMutation = (closeModal) => {
  const { callApi, userProfile } = useContext(UserContext);
  const { setCurrentRequest, setNavigation } = useContext(CheckUpContext);
  const queryClient = useQueryClient();

  return useMutation(
    ({ request }) =>
      callApi(`/checkUp/request/submit-request/${request?.id}`, {
        method: "PUT",
        headers: {
          "Content-Type": "application/json",
        },
      }),
    {
      onSuccess: () => {
        if (closeModal) {
          closeModal();
          setCurrentRequest();
          setNavigation();
          queryClient.invalidateQueries(["requests", JSON.stringify(userProfile)]);
        }
      },
    }
  );
};

export default useCheckUpCompleteMutation;
